import { AxiosInstance } from 'axios'
import { getLanguageMenuSettings, GetLanguageMenuSettingsArgs } from '@/shared/api/strapi/requests'
import {
  GetSpecialistsArgs,
  GetSpecialistArgs,
  GetSpecialistPageBlockArgs,
  GetSpecialistSeoArgs,
  GetSpecialistsPageBlockArgs,
  GetSpecialistsPageBlockSeoArgs,
  specialistApi,
} from './requests/specialist'
import {
  newsApi,
  GetNewsPageBlockArgs,
  GetNewsArgs as GetNewsArgsForNewsPage,
  GetNewsDetailsArgs,
  GetNewsPageBlockSeoArgs,
  GetNewsDetailsSeoArgs,
} from './requests/news'
import {
  serviceApi,
  GetMainServiceCategoryArgs,
  GetServiceCategoryDetailsArgs,
  GetServicesMainPageArgs,
  GetServicesPageBlockArgs,
  GetServiceCategoryPageBlocksArgs,
  GetServiceArgs,
  GetServiceCategoriesDetailsSeoArgs,
  GetServiceMainPageSeoArgs,
  GetServiceSeoArgs,
  getAllServiceCategories,
  GetAllServiceCategoriesArgs,
  getAllServices,
  GetAllServicesArgs,
  getAllDecisions,
  GetAllDecisionsArgs,
} from './requests/service'
import { ourHistoryApi, GetAboutArgs, GetSeoArgs as GetSeoOurHistoryArgs } from './requests/ourHistory'
import { contactsApi, GetContactsArgs, GetSeoArgs as GetSeoArgsContacts } from '@/shared/api/strapi/requests/contacts'
import {
  GetCelebritiesArgs,
  homeApi,
  GetOurHistoryArgs,
  GetNewsArgs,
  GetOurClinicArgs,
  GetServicesArgs,
  GetSpecialistsArgs as GetSpecialistsArgsHome,
  GetSeoArgs as GetSeoArgsHome,
  GetPageBlockArgs,
} from '@/shared/api/strapi/requests/home'
import { getPromotions, GetPromotionsArgs } from '@/shared/api/strapi/requests/promo'
import { getModalsBlock, GetModalsBlockArgs } from '@/shared/api/strapi/requests/getModalsBlock'
import { postForm } from '@/shared/api/strapi/requests/postForm'
import { getDocuments, GetDocumentsArgs } from '@/shared/api/strapi/requests/getDocuments'
import {
  getSearchNews,
  GetSearchNewsArgs,
  getSearchServices,
  GetSearchServicesArgs,
  getSearchSpecialists,
  GetSearchSpecialistsArgs,
} from '@/shared/api/strapi/requests/search'

export const StrapiApi = (client: AxiosInstance) => ({
  home: {
    getOurHistory: (args: GetOurHistoryArgs) => homeApi.getOurHistory(client, args),
    getCelebrities: (args: GetCelebritiesArgs) => homeApi.getCelebrities(client, args),
    getNews: (args: GetNewsArgs) => homeApi.getNews(client, args),
    getOurClinic: (args: GetOurClinicArgs) => homeApi.getOurClinic(client, args),
    getServices: (args: GetServicesArgs) => homeApi.getServices(client, args),
    getSpecialists: (args: GetSpecialistsArgsHome) => homeApi.getSpecialists(client, args),
    getSeo: (args: GetSeoArgsHome) => homeApi.getSeo(client, args),
    getPageBlock: (args: GetPageBlockArgs) => homeApi.getPageBlock(client, args),
  },

  getLanguageMenuSettings: (args: GetLanguageMenuSettingsArgs) => getLanguageMenuSettings(client, args),
  getModalsBlock: (args: GetModalsBlockArgs) => getModalsBlock(client, args),
  postForm: (data: Record<string, FormDataEntryValue>) => postForm(client, data),
  getDocuments: (args: GetDocumentsArgs) => getDocuments(client, args),

  ourHistory: {
    getAbout: (args: GetAboutArgs) => ourHistoryApi.getAbout(client, args),
    getSeo: (args: GetSeoOurHistoryArgs) => ourHistoryApi.getSeo(client, args),
  },
  contacts: {
    getContacts: (args: GetContactsArgs) => contactsApi.getContacts(client, args),
    getSeo: (args: GetSeoArgsContacts) => contactsApi.getSeo(client, args),
  },
  news: {
    getNewsPageBlock: (args: GetNewsPageBlockArgs) => newsApi.getNewsPageBlock(client, args),
    getNews: (args: GetNewsArgsForNewsPage) => newsApi.getNews(client, args),
    getNewsDetails: (args: GetNewsDetailsArgs) => newsApi.getNewsDetails(client, args),
    getNewsPageBlockSeo: (args: GetNewsPageBlockSeoArgs) => newsApi.getNewsPageBlockSeo(client, args),
    getNewsDetailsSeo: (args: GetNewsDetailsSeoArgs) => newsApi.getNewsDetailsSeo(client, args),
  },
  specialist: {
    getShowcaseSpecialistsList: (args: GetSpecialistsArgs) =>
      specialistApi.getSpecialistsInSpecialistsPageBlock(client, args),
    getShowcaseSpecialistsPageBlock: (args: GetSpecialistsPageBlockArgs) =>
      specialistApi.getSpecialistsPageBlock(client, args),
    getSpecialistPageBlock: (args: GetSpecialistPageBlockArgs) => specialistApi.getSpecialistPageBlock(client, args),
    getSpecialistDetails: (args: GetSpecialistArgs) => specialistApi.getSpecialist(client, args),
    getSpecialistSeo: (args: GetSpecialistSeoArgs) => specialistApi.getSpecialistSeo(client, args),
    getSpecialistsPageBlockSeo: (args: GetSpecialistsPageBlockSeoArgs) =>
      specialistApi.getSpecialistsPageBlockSeo(client, args),
  },
  service: {
    getMainServiceCategories: (args: GetMainServiceCategoryArgs) => serviceApi.getMainServiceCategories(client, args),
    getServiceCategoryDetails: (args: GetServiceCategoryDetailsArgs) =>
      serviceApi.getServiceCategoryDetails(client, args),
    getServicesMainPage: (args: GetServicesMainPageArgs) => serviceApi.getServicesMainPage(client, args),
    getServicesPageBlock: (args: GetServicesPageBlockArgs) => serviceApi.getServicesPageBlock(client, args),
    getServiceCategoryPageBlocks: (args: GetServiceCategoryPageBlocksArgs) =>
      serviceApi.getServiceCategoryPageBlocks(client, args),
    getService: (args: GetServiceArgs) => serviceApi.getService(client, args),
    getServiceCategoriesDetailsSeo: (args: GetServiceCategoriesDetailsSeoArgs) =>
      serviceApi.getServiceCategoriesDetailsSeo(client, args),
    getServiceMainPageSeo: (args: GetServiceMainPageSeoArgs) => serviceApi.getServiceMainPageSeo(client, args),
    getServiceSeo: (args: GetServiceSeoArgs) => serviceApi.getServiceSeo(client, args),
    getAllServiceCategories: (args: GetAllServiceCategoriesArgs) => getAllServiceCategories(client, args),
    getAllServices: (args: GetAllServicesArgs) => getAllServices(client, args),
    getAllDecisions: (args: GetAllDecisionsArgs) => getAllDecisions(client, args),
  },
  promo: {
    getPromotions: (args: GetPromotionsArgs) => getPromotions(client, args),
  },
  search: {
    getSearchSpecialists: (args: GetSearchSpecialistsArgs) => getSearchSpecialists(client, args),
    getSearchNews: (args: GetSearchNewsArgs) => getSearchNews(client, args),
    getSearchServices: (args: GetSearchServicesArgs) => getSearchServices(client, args),
  },
})
